import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { track } from '@amplitude/analytics-browser'
import { aICreatorGenerateOutlineAction } from 'src/reducers/ai-creator/action'
import { normalizeImageSourceByAttachments } from '../utils/attachment'
export const useOutlineGenerator = ({
  courseAbout,
  courseLanguageCode,
  attachments,
  goals,
  documentFollowing,
  onOutlineGenerated,
}) => {
  const dispatch = useDispatch()
  const [selectedSettings, setSelectedSettings] = useState([])
  const [outlineCreditCost, setOutlineCreditCost] = useState(0)

  const settingsChangeHandler = value => {
    setSelectedSettings(value)
  }

  const generateOutline = () => {
    track('generate_outline')

    // Transform settings to the format expected by the API
    const settingsObject = selectedSettings.reduce((acc, item) => {
      acc[item.key] = item.value
      return acc
    }, {})

    const normalizedImageSource = normalizeImageSourceByAttachments(
      settingsObject.imageSource,
      attachments,
    )
    if (normalizedImageSource !== undefined) {
      settingsObject.imageSource = normalizedImageSource
    }

    // Prepare the request payload
    const requestData = {
      topic: courseAbout,
      languageCode: courseLanguageCode,
      attachmentIds: attachments.map(att => att.attachment_id),
      goals: goals.filter(goal => goal.trim() !== ''),
      ...settingsObject, // Spread all selected settings
    }

    // Only include documentFollowing if there are attachments
    if (attachments.length > 0) {
      requestData.documentFollowing = documentFollowing
    }

    dispatch(
      aICreatorGenerateOutlineAction(requestData, response => {
        if (response && response.outline) {
          if (response.credit_cost) {
            setOutlineCreditCost(response.credit_cost)
          }
          track('outline_generated_successfully')
          onOutlineGenerated(response) // Pass the full response up
        } else {
          track('outline_generation_failed')
        }
      }),
    )
  }

  return {
    settingsChangeHandler,
    generateOutline,
    outlineCreditCost,
  }
}
